// Translations dictionary for DogCenter Lappland AB
// Supported: de (default), en, sv

export const LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "sv", label: "SE" },
];

export const dict = {
  de: {
    nav: {
      services: "Leistungen",
      vision: "Vision",
      contact: "Kontakt",
      cta: "Newsletter",
    },
    hero: {
      overline: "Coming Soon · 2026",
      titleA: "Ein neues Zuhause für",
      titleB: "Hundetraining im hohen Norden.",
      subtitle:
        "DogCenter Lappland AB — spezialisiertes Hundetraining, Verhaltensrehabilitation und Ernährungsberatung. Online, mobil und bald vor Ort in Kristineberg, Schwedisch Lappland.",
      ctaPrimary: "Frühen Zugang sichern",
      ctaSecondary: "Mehr erfahren",
      scroll: "Scrollen",
    },
    vision: {
      overline: "Unsere Vision",
      title:
        "Ein Ort zwischen Wald, Schnee und Stille — gewidmet dem partnerschaftlichen Training von Mensch und Hund.",
      body:
        "Wir verbinden moderne Verhaltenswissenschaft mit nordischer Ruhe. Vom ersten Online-Kurs bis zum geplanten Trainingszentrum in Lappland — mit Indoor- und Outdoor-Flächen, Maulkorb-Werkstatt, Premium-Hundefachgeschäft, BARF-Beratung und Residenz-Trainingsprogrammen.",
    },
    about: {
      overline: "Über mich",
      name: "Judith Seel",
      role: "Hundetrainerin · Verhaltensberaterin",
      lead:
        "Nicht jeder Hund funktioniert problemlos in unserem Alltag. Manche Hunde reagieren mit Angst, Unsicherheit, Aggression oder dauerhaft hohem Stress. Andere wirken „schwierig“, obwohl sie schlicht überfordert, missverstanden oder ständig unter Spannung stehen.",
      focus:
        "Mein Schwerpunkt liegt auf Verhalten im echten Leben — nicht auf perfekten Trainingsplätzen oder schnellen Standardlösungen. Mich interessieren die Ursachen hinter Verhalten, die Dynamik zwischen Mensch und Hund und die Frage, wie Sicherheit, Verständnis und Alltag wieder zusammenfinden können.",
      topicsLabel: "Schwerpunkte",
      topics: [
        "Angst und Unsicherheit",
        "Aggressionsverhalten",
        "Stress und Überforderung",
        "Tierschutz- und Auslandshunde",
        "Management und Gefahrenreduktion",
        "Alltagstraining",
        "Körpersprache und Kommunikation",
        "Mehrhundehaltung und soziale Dynamiken",
      ],
      philosophy:
        "Ich verbinde Verhaltenstraining mit praxisnahem Management und einem realistischen Blick auf den Alltag. Nicht jedes Problem lässt sich „wegtrainieren“ — und nicht jeder Hund braucht einfach nur mehr Gehorsam. Mir geht es darum, Hunde ernst zu nehmen, Verhalten zu verstehen und gemeinsam tragfähige Lösungen zu entwickeln, die langfristig funktionieren.",
      north:
        "Heute lebe und arbeite ich mit meinen eigenen Hunden im Norden Schwedens. Viele davon stammen selbst aus dem Tierschutz und bringen ihre ganz eigenen Herausforderungen mit. Diese Erfahrungen prägen auch meine Arbeit.",
      credsLabel: "Fachliche Grundlage",
      creds:
        "Ausbildungen im Bereich Hundetraining und Hundeverhaltensberatung sowie kontinuierliche Weiterbildungen rund um Verhalten, Stress, Körpersprache und moderne Trainingsansätze.",
      quote:
        "Ehrliches Training, individuelle Lösungen und ein klarer Blick auf Verhalten — für Menschen, die bereit sind, genauer hinzusehen.",
    },
    services: {
      overline: "Leistungen im Überblick",
      title: "Spezialisiert. Persönlich. Wissenschaftlich fundiert.",
      items: [
        {
          name: "Online-Training",
          desc: "Strukturierte Online-Programme für Alltag, Aufbau und Spezialisierung — ortsunabhängig begleitet.",
        },
        {
          name: "Verhaltensrehabilitation",
          desc: "Langfristige, individuelle Konzepte für komplexe Verhaltensfälle — mit Geduld und Methode.",
        },
        {
          name: "Mobiles Training",
          desc: "Wir kommen zu Ihnen: Training im echten Alltag, an den Orten, an denen es wirklich zählt.",
        },
        {
          name: "Ernährungsberatung",
          desc: "Individuelle Ernährungs- und BARF-Beratung für Hund und Katze — fundiert und alltagstauglich.",
        },
      ],
    },
    newsletter: {
      overline: "Vorab informiert",
      title: "Seien Sie die Ersten, die es erfahren.",
      desc: "Newsletter abonnieren und exklusive Vorab-Informationen zum Launch 2026 erhalten.",
      placeholder: "Ihre E-Mail-Adresse",
      button: "Anmelden",
      success: "Fast geschafft — wir haben Ihnen einen Bestätigungslink per E-Mail gesendet.",
      already: "Diese Adresse ist bereits angemeldet.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      consent: {
        before: "Mit der Anmeldung stimmen Sie dem Versand des Newsletters und der Verarbeitung Ihrer E-Mail-Adresse gemäß unserer ",
        link: "Datenschutzerklärung",
        after: " zu. Sie können sich jederzeit wieder abmelden.",
      },
    },
    contact: {
      overline: "Kontakt",
      title: "Schreiben Sie uns.",
      desc: "Fragen, Kooperationen, Presse — wir freuen uns auf Ihre Nachricht.",
      name: "Name",
      email: "E-Mail",
      message: "Ihre Nachricht",
      button: "Nachricht senden",
      success: "Vielen Dank — wir melden uns in Kürze.",
      error: "Nachricht konnte nicht gesendet werden.",
      required: "Bitte alle Felder ausfüllen.",
    },
    footer: {
      tagline: "Spezialisiertes Hundezentrum · Kristineberg, Schwedisch Lappland",
      rights: "Alle Rechte vorbehalten.",
      legal: "Impressum",
      privacy: "Datenschutz",
    },
    cookie: {
      title: "Hinweis zu Cookies & Datenschutz",
      body:
        "Diese Website verwendet keine Tracking- oder Analyse-Cookies. Wir speichern lediglich Ihre Sprachwahl lokal in Ihrem Browser. Schriftarten werden direkt von unserem Server geladen — es findet keine Übermittlung an Google statt.",
      accept: "Verstanden",
      more: "Datenschutz lesen",
    },
  },
  en: {
    nav: {
      services: "Services",
      vision: "Vision",
      contact: "Contact",
      cta: "Newsletter",
    },
    hero: {
      overline: "Coming Soon · 2026",
      titleA: "A new home for",
      titleB: "dog training in the far north.",
      subtitle:
        "DogCenter Lappland AB — specialised dog training, behavioural rehabilitation and nutrition consulting. Online, mobile, and soon on-site in Kristineberg, Swedish Lapland.",
      ctaPrimary: "Get early access",
      ctaSecondary: "Learn more",
      scroll: "Scroll",
    },
    vision: {
      overline: "Our Vision",
      title:
        "A place between forest, snow and silence — dedicated to partnership-based training of dog and human.",
      body:
        "We combine modern behavioural science with Nordic calm. From the first online course to the planned training centre in Lapland — with indoor and outdoor facilities, muzzle fitting workshop, premium dog supply store, BARF consulting and residential training programs.",
    },
    about: {
      overline: "About me",
      name: "Judith Seel",
      role: "Dog trainer · Behaviour consultant",
      lead:
        "Not every dog works well in our everyday life. Some respond with fear, insecurity, aggression or constantly elevated stress. Others appear „difficult“, when in reality they are simply overwhelmed, misunderstood or permanently under tension.",
      focus:
        "My focus is on behaviour in real life — not perfect training fields or quick standard solutions. I'm interested in the causes behind behaviour, in the dynamics between human and dog, and in the question of how safety, understanding and daily life can come back together.",
      topicsLabel: "Areas of work",
      topics: [
        "Fear and insecurity",
        "Aggressive behaviour",
        "Stress and overload",
        "Rescue dogs and dogs from abroad",
        "Management and risk reduction",
        "Everyday training",
        "Body language and communication",
        "Multi-dog households and social dynamics",
      ],
      philosophy:
        "I combine behavioural training with practical management and a realistic view of everyday life. Not every problem can be „trained away“ — and not every dog simply needs more obedience. What matters to me is taking dogs seriously, understanding behaviour, and developing sustainable solutions together that work in the long run.",
      north:
        "Today I live and work with my own dogs in the north of Sweden. Many of them come from animal welfare backgrounds themselves and bring their own challenges with them. These experiences shape my work.",
      credsLabel: "Professional background",
      creds:
        "Certified training in dog handling and canine behaviour consulting, plus ongoing professional development in behaviour, stress, body language and modern training approaches.",
      quote:
        "Honest training, individual solutions and a clear view of behaviour — for people who are ready to look more closely.",
    },
    services: {
      overline: "An overview of our services",
      title: "Specialised. Personal. Science-based.",
      items: [
        {
          name: "Online Training",
          desc: "Structured online programs for everyday life, advanced work and specialisation — guided remotely.",
        },
        {
          name: "Behavioural Rehabilitation",
          desc: "Long-term, individual concepts for complex behavioural cases — with patience and method.",
        },
        {
          name: "Mobile Training",
          desc: "We come to you: training in real-life situations, in the places where it actually matters.",
        },
        {
          name: "Nutrition Consulting",
          desc: "Individual nutrition and BARF consulting for dogs and cats — well-founded and practical.",
        },
      ],
    },
    newsletter: {
      overline: "Stay informed",
      title: "Be the first to know.",
      desc: "Subscribe to the newsletter and receive exclusive updates about our 2026 launch.",
      placeholder: "Your email address",
      button: "Subscribe",
      success: "Almost done — we’ve sent you a confirmation link by email.",
      already: "This address is already subscribed.",
      error: "Something went wrong. Please try again.",
      invalid: "Please enter a valid email address.",
      consent: {
        before: "By subscribing, you agree to receive our newsletter and to the processing of your email address according to our ",
        link: "Privacy Policy",
        after: ". You can unsubscribe at any time.",
      },
    },
    contact: {
      overline: "Contact",
      title: "Send us a message.",
      desc: "Questions, partnerships, press — we look forward to hearing from you.",
      name: "Name",
      email: "Email",
      message: "Your message",
      button: "Send message",
      success: "Thank you — we'll be in touch shortly.",
      error: "Message could not be sent.",
      required: "Please fill in all fields.",
    },
    footer: {
      tagline: "Specialised dog centre · Kristineberg, Swedish Lapland",
      rights: "All rights reserved.",
      legal: "Imprint",
      privacy: "Privacy",
    },
    cookie: {
      title: "Cookies & privacy",
      body:
        "This website does not use tracking or analytics cookies. We only store your language preference locally in your browser. Web fonts are served directly from our server — no data is transferred to Google.",
      accept: "Got it",
      more: "Read privacy policy",
    },
  },
  sv: {
    nav: {
      services: "Tjänster",
      vision: "Vision",
      contact: "Kontakt",
      cta: "Nyhetsbrev",
    },
    hero: {
      overline: "Kommer snart · 2026",
      titleA: "Ett nytt hem för",
      titleB: "hundträning i norr.",
      subtitle:
        "DogCenter Lappland AB — specialiserad hundträning, beteenderehabilitering och näringsrådgivning. Online, mobilt och snart på plats i Kristineberg, svenska Lappland.",
      ctaPrimary: "Få tidig tillgång",
      ctaSecondary: "Läs mer",
      scroll: "Skrolla",
    },
    vision: {
      overline: "Vår vision",
      title:
        "En plats mellan skog, snö och stillhet — tillägnad partnerskapsbaserad träning av hund och människa.",
      body:
        "Vi kombinerar modern beteendevetenskap med nordiskt lugn. Från den första onlinekursen till det planerade träningscentret i Lappland — med inomhus- och utomhusanläggningar, munkorgsverkstad, premiumbutik för hundtillbehör, BARF-rådgivning och boendeträningsprogram.",
    },
    about: {
      overline: "Om mig",
      name: "Judith Seel",
      role: "Hundtränare · Beteenderådgivare",
      lead:
        "Alla hundar fungerar inte problemfritt i vardagen. En del reagerar med rädsla, osäkerhet, aggression eller varaktigt hög stress. Andra verkar „svåra“ trots att de helt enkelt är överbelastade, missförstådda eller ständigt under spänning.",
      focus:
        "Mitt fokus ligger på beteende i verkliga livet — inte på perfekta träningsplaner eller snabba standardlösningar. Jag är intresserad av orsakerna bakom beteendet, av dynamiken mellan människa och hund och av frågan hur trygghet, förståelse och vardag åter kan mötas.",
      topicsLabel: "Områden jag arbetar med",
      topics: [
        "Rädsla och osäkerhet",
        "Aggressivt beteende",
        "Stress och överbelastning",
        "Räddningshundar och utlandshundar",
        "Management och riskreducering",
        "Vardagsträning",
        "Kroppsspråk och kommunikation",
        "Flerhundshushåll och sociala dynamiker",
      ],
      philosophy:
        "Jag kombinerar beteendeträning med praktisk management och en realistisk syn på vardagen. Alla problem kan inte „tränas bort“ — och alla hundar behöver inte bara mer lydnad. Det handlar för mig om att ta hundar på allvar, förstå beteendet och tillsammans utveckla hållbara lösningar som fungerar långsiktigt.",
      north:
        "Idag bor och arbetar jag med mina egna hundar i norra Sverige. Många av dem kommer själva från djurskydd och har sina helt egna utmaningar. Dessa erfarenheter präglar också mitt arbete.",
      credsLabel: "Yrkesmässig grund",
      creds:
        "Utbildning inom hundträning och hundbeteenderådgivning samt kontinuerlig fortbildning kring beteende, stress, kroppsspråk och moderna träningsmetoder.",
      quote:
        "Ärlig träning, individuella lösningar och en tydlig blick på beteendet — för människor som är beredda att titta närmare.",
    },
    services: {
      overline: "En översikt av våra tjänster",
      title: "Specialiserat. Personligt. Vetenskapsbaserat.",
      items: [
        {
          name: "Onlineträning",
          desc: "Strukturerade onlineprogram för vardag, fördjupning och specialisering — handledning på distans.",
        },
        {
          name: "Beteenderehabilitering",
          desc: "Långsiktiga, individuella koncept för komplexa beteendefall — med tålamod och metod.",
        },
        {
          name: "Mobil träning",
          desc: "Vi kommer till dig: träning i verkliga situationer, på platser där det verkligen betyder något.",
        },
        {
          name: "Näringsrådgivning",
          desc: "Individuell närings- och BARF-rådgivning för hund och katt — väl underbyggd och praktisk.",
        },
      ],
    },
    newsletter: {
      overline: "Håll dig uppdaterad",
      title: "Var först med att få veta.",
      desc: "Prenumerera på nyhetsbrevet och få exklusiva uppdateringar inför lanseringen 2026.",
      placeholder: "Din e-postadress",
      button: "Prenumerera",
      success: "Nästan klart — vi har skickat en bekräftelselänk till din e-post.",
      already: "Denna adress är redan registrerad.",
      error: "Något gick fel. Försök igen.",
      invalid: "Vänligen ange en giltig e-postadress.",
      consent: {
        before: "Genom att prenumerera godkänner du att vi skickar nyhetsbrevet och behandlar din e-postadress enligt vår ",
        link: "Integritetspolicy",
        after: ". Du kan avregistrera dig när som helst.",
      },
    },
    contact: {
      overline: "Kontakt",
      title: "Skriv till oss.",
      desc: "Frågor, samarbeten, press — vi ser fram emot att höra från dig.",
      languageNote:
        "Judith håller på att lära sig svenska — för en smidig kommunikation föredrar vi tills vidare engelska eller tyska. Tack för förståelsen!",
      name: "Namn",
      email: "E-post",
      message: "Ditt meddelande",
      button: "Skicka meddelande",
      success: "Tack — vi hör av oss inom kort.",
      error: "Meddelandet kunde inte skickas.",
      required: "Vänligen fyll i alla fält.",
    },
    footer: {
      tagline: "Specialiserat hundcenter · Kristineberg, svenska Lappland",
      rights: "Alla rättigheter förbehållna.",
      legal: "Företagsinformation",
      privacy: "Integritet",
    },
    cookie: {
      title: "Kakor & integritet",
      body:
        "Denna webbplats använder inga spårnings- eller analyskakor. Vi sparar endast ditt språkval lokalt i din webbläsare. Typsnitt levereras direkt från vår server — ingen data överförs till Google.",
      accept: "Jag förstår",
      more: "Läs integritetspolicy",
    },
  },
};

export const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((email || "").trim());
